import React from "react";
import { Filter, SelectInput } from "react-admin";
import { styles } from "../styles";

export default (props) => (
  <Filter {...props}>
    <SelectInput
      alwaysOn
      label="From"
      addLabel
      source="startDatetimeFrom"
      choices={[
        { id: "today", name: "today" },
        { id: "week", name: "this week" },
      ]}
      style={styles.input}
    />
    <SelectInput
      alwaysOn
      label="To"
      addLabel
      source="startDatetimeTo"
      choices={[
        { id: "today", name: "today" },
        { id: "week", name: "this week" },
      ]}
      style={styles.input}
    />
  </Filter>
);



// WEBPACK FOOTER //
// ./src/rides/RideFilter.js